import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { ifDefined } from "lit/directives/if-defined.js";
import { litIf } from "../LitUtils";
import { watch } from "../internal/watch";
import { IUserInfo } from "../../backend/cloud/UserTable";

import "../SocialLinks/SocialLinks";

@customElement("ds-profile-badge")
export class ProfileBadge extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .user-name {
                align-items: center;
            }

            .user-name sl-icon {
                font-size: 1.5em;
            }

            .detail-text {
                font-size: 0.8em;
                float: right;
            }

            .text-column {
                gap: 0.1em;
            }

            sl-avatar {
                --size: 2em;
            }
        `,
    ];
    @property({ type: String }) detailText?: string;
    @property({ type: String }) user?: string;
    @property({ type: String }) link?: string;
    @property({ type: Boolean }) hideSocialLinks = false;

    @state() protected _userInfo?: IUserInfo;
    @state() protected _userAvatarUrl?: string;

    @watch("user")
    async _userUpdated(_oldValue: any, newValue: any) {
        this._userInfo = undefined;
        this._userAvatarUrl = undefined;
        if (newValue) {
            const us = this._kernel.userSettings;
            this._userInfo = await us.read(this.user);

            if (this._userInfo) {
                this._userAvatarUrl = await us.getAvatarURL(this._userInfo);
            }
        }
    }

    override render() {
        return html`<div class="container flex-row user-name">
            ${litIf(
                this._userInfo,
                () => html`
                    <sl-avatar
                        class="cursor-pointer"
                        image=${ifDefined(this._userAvatarUrl)}
                        @click=${() =>
                            this._kernel.events.raiseEvent("ds-user-selected", this.user)}
                    ></sl-avatar>
                    <div class="flex-column text-column">
                        <div class="flex-row">
                            <span
                                class="cursor-pointer"
                                part="display-name"
                                @click=${() =>
                                    this._kernel.events.raiseEvent("ds-user-selected", this.user)}
                            >
                                ${litIf(
                                    this.user,
                                    () => html`${this._userInfo?.displayName ?? "Unknown"}`,
                                    () => html`${"Unknown"}`
                                )}</span
                            >
                            <ds-social-links
                                .socials=${this._userInfo?.socials ?? undefined}
                            ></ds-social-links>
                        </div>
                        ${litIf(
                            this.detailText,
                            () => html` <span class="detail-text">${this.detailText}</span>`
                        )}
                    </div>
                `
            )}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-profile-badge": ProfileBadge;
    }
}
